import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const PLAN_Z_BOGO_I18N_NAMESPACE =
  '@mc/checkout/experiments/prcng-955_v1'

export const i18nInstance = registerI18nResources({
  namespace: PLAN_Z_BOGO_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
